module.exports = __webpack_public_path__ + "img/74.2.TN.195963d7.png";